export const DASHBOARD_USER_ROLES = {
  EMPLOYER: "employer",
  BROKER: "broker",
  GA: "ga",
  ADMIN: "admin",
  NATIONAL: "national",
};

export const singularRoleLabels = {
  employer: "Employer",
  broker: "Broker",
  ga: "GA",
  admin: "Admin",
  national: "National",
};

export const textRoles = {
  national: "National",
  ga: "GA",
  employers: "Employer",
  brokers: "Broker",
  employees: "Employee",
};

export const onboardingStepsEnum = {
  WelcomeStep: 0,
  StepOneBroker: 1,
  StepOne: 1,
  PaymentStep: 2,
  EmployerEmployeesStep: 3,
  AgreementStep: 4,
};

export const usStatesAbreviated = [
  { name: "Alabama", abbreviation: "AL" },
  { name: "Alaska", abbreviation: "AK" },
  { name: "Arizona", abbreviation: "AZ" },
  { name: "Arkansas", abbreviation: "AR" },
  { name: "California", abbreviation: "CA" },
  { name: "Colorado", abbreviation: "CO" },
  { name: "Connecticut", abbreviation: "CT" },
  { name: "Delaware", abbreviation: "DE" },
  { name: "Florida", abbreviation: "FL" },
  { name: "Georgia", abbreviation: "GA" },
  { name: "Hawaii", abbreviation: "HI" },
  { name: "Idaho", abbreviation: "ID" },
  { name: "Illinois", abbreviation: "IL" },
  { name: "Indiana", abbreviation: "IN" },
  { name: "Iowa", abbreviation: "IA" },
  { name: "Kansas", abbreviation: "KS" },
  { name: "Kentucky", abbreviation: "KY" },
  { name: "Louisiana", abbreviation: "LA" },
  { name: "Maine", abbreviation: "ME" },
  { name: "Maryland", abbreviation: "MD" },
  { name: "Massachusetts", abbreviation: "MA" },
  { name: "Michigan", abbreviation: "MI" },
  { name: "Minnesota", abbreviation: "MN" },
  { name: "Mississippi", abbreviation: "MS" },
  { name: "Missouri", abbreviation: "MO" },
  { name: "Montana", abbreviation: "MT" },
  { name: "Nebraska", abbreviation: "NE" },
  { name: "Nevada", abbreviation: "NV" },
  { name: "New Hampshire", abbreviation: "NH" },
  { name: "New Jersey", abbreviation: "NJ" },
  { name: "New Mexico", abbreviation: "NM" },
  { name: "New York", abbreviation: "NY" },
  { name: "North Carolina", abbreviation: "NC" },
  { name: "North Dakota", abbreviation: "ND" },
  { name: "Ohio", abbreviation: "OH" },
  { name: "Oklahoma", abbreviation: "OK" },
  { name: "Oregon", abbreviation: "OR" },
  { name: "Pennsylvania", abbreviation: "PA" },
  { name: "Rhode Island", abbreviation: "RI" },
  { name: "South Carolina", abbreviation: "SC" },
  { name: "South Dakota", abbreviation: "SD" },
  { name: "Tennessee", abbreviation: "TN" },
  { name: "Texas", abbreviation: "TX" },
  { name: "Utah", abbreviation: "UT" },
  { name: "Vermont", abbreviation: "VT" },
  { name: "Virginia", abbreviation: "VA" },
  { name: "Washington", abbreviation: "WA" },
  { name: "West Virginia", abbreviation: "WV" },
  { name: "Wisconsin", abbreviation: "WI" },
  { name: "Wyoming", abbreviation: "WY" },
  { name: "District of Columbia", abbreviation: "DC" },
  { name: "Puerto Rico", abbreviation: "PR" },
  { name: "Guam", abbreviation: "GU" },
  { name: "American Samoa", abbreviation: "AS" },
  { name: "U.S. Virgin Islands", abbreviation: "VI" },
  { name: "Northern Mariana Islands", abbreviation: "MP" },
];

export const INDIVIDUAL_STATUS = {
  ACTIVE: "active",
  TERMINATED: "terminated",
  INVITED: "invited",
  INACTIVE: "inactive",
};

export const EMPLOYEE_STATUS = {
  PendingActivation: "pending_activation", // Added but not going to be active in the next effective date
  ActiveNextEffectiveDate: "active_next_effective_date", // Going to be active in the next effective date
  CurrentlyActive: "active", // Became active
  Terminated: "terminated", // Terminated
  TerminatedNextEffectiveDate: "terminated_next_effective_date", // Going to be terminated in the next effective date
};

export const employeeStatusLabels = {
  [EMPLOYEE_STATUS.PendingActivation]: "Pending",
  [EMPLOYEE_STATUS.ActiveNextEffectiveDate]: "Active Next Effective Date",
  [EMPLOYEE_STATUS.CurrentlyActive]: "Active",
  [EMPLOYEE_STATUS.Terminated]: "Terminated",
  [EMPLOYEE_STATUS.TerminatedNextEffectiveDate]:
    "Terminated Next Effective Date",
};

export const statusToBadgeColor = {
  [EMPLOYEE_STATUS.PendingActivation]: "warning",
  [EMPLOYEE_STATUS.ActiveNextEffectiveDate]: "info",
  [EMPLOYEE_STATUS.CurrentlyActive]: "success",
  [EMPLOYEE_STATUS.Terminated]: "danger",
  [EMPLOYEE_STATUS.TerminatedNextEffectiveDate]: "danger",
};

export const commissionDetailsType = {
  employer_employees: "Employees",
  individual: "Individual",
};
